import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ErrorAlert } from '../../../../../../icons/ErrorAlert';
import STRING_KEYS from '../../../../../../language/keys';
import { ProgressBar } from '../../ProgressBar';
import { style } from './style';

type RunStatusErrorProps = {
  message: string,
}

export const RunStatusError = ({
  message,
}: RunStatusErrorProps):JSX.Element => {
  const { t: translate } = useTranslation();

  return (
    <Box>
      <ProgressBar
        value={ 100 }
        color="#D14343"
      />
      <Box sx={ style.box.sx }>
        <ErrorAlert fill="#D14343" />
        <Typography variant="overline" sx={ style.typograpyStatus.sx }>
          {translate(STRING_KEYS.ERROR)}
        </Typography>
        <Typography variant="caption" sx={ style.typograpyDesc.sx }>
          {message}
        </Typography>
      </Box>
    </Box>
  );
};
